import { Component } from '@angular/core';

@Component({
    selector: 'app-maintenance-screen',
    templateUrl: './maintenance-screen.component.html',
    styleUrls: ['./maintenance-screen.component.scss']
})
export class MaintenanceScreenComponent {}
